<div class="modal-background" [ngClass]="{'in-canvas': inCanvas}" *ngIf="isOpen">
    <div class="p-6 bg-white flex-col justify-center items-center inline-flex" [style.max-width]="maxWidth ? maxWidth + 'px' : ''">
        <div class="flex flex-row justify-end w-full relative -top-2 cursor-pointer">
            <img (click)="close()" src="assets/icons/close.svg" alt="close" />
        </div>
        <div class="flex flex-col justify-center items-center gap-6">
            <div *ngIf="(!twoSteps || currentStep === 1) && (title || message)" class="self-stretch flex-col justify-center items-start gap-2 flex">
                <div class="self-stretch text-center typography-title-m">{{ title }}</div>
                <div class="flex flex-col">
                    <div class="self-stretch text-center text-text-secondary typography-body-l-regular" [innerHTML]="message"></div>
                    <div class="self-stretch text-center text-text-secondary typography-body-l-regular" [innerHTML]="messageTwo"></div>
                </div>
            </div>
            <ng-container *ngIf="!twoSteps || currentStep === 2">
                <ng-content></ng-content>
            </ng-container>
            <div class="flex flex-col justify-center items-center gap-4" [ngClass]="{'flex-row flex-wrap': buttonsInRow, 'flex-col': !buttonsInRow}" *ngIf="!hideFooter">
                <div class="justify-center items-center flex" *ngIf="cancelText">
                    <app-button
                        [primary]="cancelButtonStyle === 'primary'"
                        [secondary]="cancelButtonStyle === 'secondary'"
                        [ghost]="cancelButtonStyle === 'ghost'"
                        (onClick)="cancel()"
                        [gtmLabel]="gtmLabelCancel"
                    >
                        {{ cancelText || 'Cancel' | translate }}
                    </app-button>
                </div>
                <div class="justify-center items-center flex" *ngIf="confirmText">
                    <app-button
                        [primary]="confirmButtonStyle === 'primary'"
                        [secondary]="confirmButtonStyle === 'secondary'"
                        [ghost]="confirmButtonStyle === 'ghost'"
                        (onClick)="twoSteps && currentStep === 1 ? (currentStep = 2) : confirm()"
                        [gtmLabel]="gtmLabelConfirm"
                    >
                        {{ confirmText || 'Confirm' | translate }}
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</div>
